import { useSearchParams } from 'react-router-dom';

import { ApplicationId } from 'interfaces';
import { createAtomFamily } from 'utils';

export type ApplicationState = {};

export type ApplicationStateStateParam = {
  applicationId: ApplicationId;
};

const { atom: editorViewAtom } = createAtomFamily<ApplicationState, ApplicationStateStateParam>({
  key: 'application',
  defaultValue: {},
});

export function useHeaderlessMode() {
  const paramName = 'headerless';
  const [searchParams] = useSearchParams();

  return searchParams.get(paramName) === '1' || searchParams.get(paramName) === 'true';
}

export { editorViewAtom };
